const createTemplateExerciseDetailsText = (exerciseTemplate) => {
  let setsText = "";
  if (exerciseTemplate.sets) {
    setsText = `${exerciseTemplate.sets} Sets`;
  }

  let repsText = "";
  if (
    exerciseTemplate.repRange &&
    exerciseTemplate.repRange.min &&
    exerciseTemplate.repRange.max
  ) {
    repsText = `${exerciseTemplate.repRange.min}-${exerciseTemplate.repRange.max} Reps`;
  } else if (
    exerciseTemplate.repRange &&
    exerciseTemplate.repRange.min &&
    !exerciseTemplate.repRange.max
  ) {
    repsText = `${exerciseTemplate.repRange.min} Reps`;
  } else if (
    exerciseTemplate.repRange &&
    !exerciseTemplate.repRange.min &&
    exerciseTemplate.repRange.max
  ) {
    repsText = `${exerciseTemplate.repRange.max} Reps`;
  }

  let restText = "";
  if (exerciseTemplate.rest) {
    if ("min" in exerciseTemplate.rest) {
      if (
        exerciseTemplate.rest.min.minutes ||
        exerciseTemplate.rest.min.seconds
      ) {
        restText += "Rest: ";
      }
    } else if ("max" in exerciseTemplate.rest) {
      if (
        exerciseTemplate.rest.max.minutes ||
        exerciseTemplate.rest.max.seconds
      ) {
        restText += "Rest: ";
      }
    }
    if ("min" in exerciseTemplate.rest) {
      if (exerciseTemplate.rest.min.minutes) {
        restText += `${exerciseTemplate.rest.min.minutes}m`;
      }
      if (
        exerciseTemplate.rest.min.minutes &&
        exerciseTemplate.rest.min.seconds
      ) {
        restText += ` `;
      }
      if (exerciseTemplate.rest.min.seconds) {
        restText += `${exerciseTemplate.rest.min.seconds}s`;
      }
    }
    if ("min" in exerciseTemplate.rest && "max" in exerciseTemplate.rest) {
      if (
        exerciseTemplate.rest.min.minutes ||
        exerciseTemplate.rest.min.seconds ||
        exerciseTemplate.rest.max.minutes ||
        exerciseTemplate.rest.max.seconds
      ) {
        restText += ` - `;
      }
    }
    if ("max" in exerciseTemplate.rest) {
      if (exerciseTemplate.rest.max.minutes) {
        restText += `${exerciseTemplate.rest.max.minutes}m`;
      }
      if (
        exerciseTemplate.rest.max.minutes &&
        exerciseTemplate.rest.max.seconds
      ) {
        restText += ` `;
      }
      if (exerciseTemplate.rest.max.seconds) {
        restText += `${exerciseTemplate.rest.max.seconds}s`;
      }
    }
  }

  let tempoText = "";
  if (exerciseTemplate.tempo) {
    if (
      exerciseTemplate.tempo.eccentric ||
      exerciseTemplate.tempo.stretchedPause ||
      exerciseTemplate.tempo.concentric ||
      exerciseTemplate.tempo.contractedPause
    ) {
      tempoText = `Tempo: ${
        exerciseTemplate.tempo.eccentric
          ? exerciseTemplate.tempo.eccentric
          : "0"
      }-${
        exerciseTemplate.tempo.stretchedPause
          ? exerciseTemplate.tempo.stretchedPause
          : "0"
      }-${
        exerciseTemplate.tempo.concentric
          ? exerciseTemplate.tempo.concentric
          : "0"
      }-${
        exerciseTemplate.tempo.contractedPause
          ? exerciseTemplate.tempo.contractedPause
          : "0"
      }`;
    }
  }

  const exerciseDetails = `${setsText ? setsText : ""}${
    setsText ? "\xa0|\xa0" : ""
  }${repsText ? repsText : ""}${repsText ? "\xa0|\xa0" : ""}${
    restText ? restText : ""
  }${(repsText || restText) && tempoText ? "\xa0|\xa0" : ""}${
    tempoText ? tempoText : ""
  }`;

  return exerciseDetails;
};

export default createTemplateExerciseDetailsText;
